import { useEffect, useState } from 'react';
import type { BulkEditOrDeleteCommands } from '../../types';
import {
  bulkDeleteOperations,
  type BulkDeleteCount,
} from './bulkDeleteOperations';

export type GetBulkDeleteComponentCount =
  BulkEditOrDeleteCommands['getBulkDeleteComponentCount'];

export const useBulkDeleteComponentCount = (
  getBulkDeleteComponentCount: GetBulkDeleteComponentCount
): BulkDeleteCount => {
  const [count, setCount] = useState<BulkDeleteCount>({ status: 'loading' });

  useEffect(() => {
    let isCurrentRequest = true;
    const settle = (settled: BulkDeleteCount) => {
      if (isCurrentRequest) {
        setCount(settled);
      }
    };
    getBulkDeleteComponentCount()
      .then(result => settle(bulkDeleteOperations.toBulkDeleteCount(result)))
      // A command that rejects rather than resolving an ArdoqError would
      // otherwise leave the dialog loading for good. The command owns logging.
      .catch(() => settle({ status: 'error' }));
    return () => {
      isCurrentRequest = false;
    };
  }, [getBulkDeleteComponentCount]);

  return count;
};
